<template>
  <div>
    <div class="topTit" id="topTit" ref="topTit" v-if="showTopTit">
      <van-icon @click.stop="goBack" name="arrow-left" color="#515151" size="0.28rem" />
      <van-notice-bar class="navText" color="#333" background="#fff" v-if="topTitle">{{topTitle}}</van-notice-bar>
      <div class="refresh" @click.stop="refreshClick">
        <img src="~assets/images/recmmendImg/refresh.png" />
      </div>
    </div>
    <Activity v-if="clientType == 1" :entryObj="entryObj"></Activity>
    <Recommend v-if="clientType == 2" :entryObj="entryObj"></Recommend>
    <SignInModule v-if="clientType == 3" :entryObj="entryObj"></SignInModule>
    <div class="maskLoading" v-show="maskLoadingflag">
      <img src="~assets/images/load.svg" alt />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapState } from "vuex";
import config from "@/../config";
import active from "@/utils/axios/index";
import qs from "qs";
import primaryApi from "@/utils/primaryApi";
import Activity from "@/views/activity"; // 活动模板
import Recommend from "@/views/recommend"; // 抽奖模块-主推游戏
import SignInModule from "@/views/signInModule"; // 活动模板3-签到活动
import { Toast, Dialog, Icon, NoticeBar } from "vant";
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(NoticeBar);
export default {
  inject: ["reload"],
  data() {
    return {
      entryObj: {}, // 模块配置基本信息
      clientType: null, // 底层模板类型，1-活动模板，2-游戏主推 3-签到活动
      maskLoadingflag: true, //首页进入页面开始的动画(转圆圈)
      topTitle: "", //头部标题
      showTopTit: false, //乐园显示顶部导航栏
    };
  },
  computed: {
    ...mapState(["guide"]),
  },
  components: {
    Activity,
    Recommend,
    SignInModule
  },
  created() {
    //233乐园后退回调
    window["goBackResult"] = (result) => {
      if (result == "failed") {
        //乐园后退失败则关闭界面
        primaryApi.closeActivity();
      }
    };
    if (primaryApi.isSource == "pd") {
      primaryApi.setNativeTitleShow(false); // 隐藏原生顶栏
      //乐园显示顶部导航栏
      this.showTopTit = true;
    }
    this.$store.commit({
      type: "setactivityId",
      activityId: this.$route.query.id,
    });
    this.getuuid();
    this.entry();
  },
  methods: {
    // 获取uuid
    getuuid() {
      var userInfo;
      if (primaryApi.isSource) {
        userInfo = JSON.parse(primaryApi.getUserInfo());
      } else {
        userInfo = {
          uuId: "55f450bb8f294050987f88f4185c2186",
          // 55f450bb8f294050987f88f4185c2186
          // 06631a0c48cc43a397e2f7c87b33224b
          onlyId: "",
          userName: "测试用户名",
        };
      }
      if (!userInfo) {
        Dialog.alert({
          title: "提示",
          message: "请前去登陆233账号^ - ^",
        });
      } else {
        var uuid = primaryApi.isSource == "sg" ? userInfo.uuid : userInfo.uuId;
        var onlyId = userInfo.onlyId;
        var userName = userInfo.userName;
        this.$store.commit({
          type: "setuuid",
          uuid,
        });
        this.$store.commit({
          type: "setonlyid",
          onlyId,
        });
        this.$store.commit({
          type: "setuserName",
          userName,
        });
      }
    },
    // 页面初始化渲染
    entry() {
      active.entry(config.API_HOST + "/apiserv/api/activity/entry", qs.stringify({
          id: this.$route.query.id,
      })).then((res) => {
          this.maskLoadingflag = false;
          if (res.return_code != 200) {
            this.$toast(res.return_msg);
            return;
          }
          this.entryObj = res.data;
          this.clientType = res.data.activityClient.clientType;
          this.topTitle = res.data.activityClient.productName; //活动题目
          // 活动开始时间
          this.$store.commit({
              type: "settime",
              time: res.data.activityServer.startTime
          });
          this.$tea("event_activemodal_show", {
            activityId: this.$route.query.id,
            type: this.clientType,
            guide: this.guide ? this.guide : false
          }); //数据埋点
      }).catch((error) => {
          this.maskLoadingflag = false;
          this.$toast("网络不稳定，请稍后");
      });
    },
    //刷新
    refreshClick() {
      this.reload();
    },
    //后退
    goBack() {
      if (primaryApi.isSource == "pd") {
        //乐园环境
        primaryApi.goBack();
      }
    },
  },
};
</script>
<style scoped>
.maskLoading {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(189, 84, 28, 0.98);
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.maskLoading img {
  display: block;
  width: 0.4rem;
  height: 0.4rem;
  animation: loading 2s linear 0s infinite;
}
@keyframes loading {
  from {
    transform: rotate(0);
  }

  to {
    transform: rotate(360deg);
  }
}
.topTit {
  width: 100%;
  height: 0.46rem;
  line-height: 0.46rem;
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 0.05rem;
}
.refresh {
  /* position: absolute; */
  /* right: 0.05rem; */
  /* top: 0; */
  height: 100%;
  width: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  font-size: 0;
}
.refresh img {
  width: 22.8px;
  height: 30.6px;
}
.refresh span {
  color: #515151;
  font-size: 0.06rem;
  line-height: 0.2rem;
  /* transform: scale(0.9, 0.9); */
  margin-top: -0.1rem;
}
.van-notice-bar {
  width: 100%;
  text-align: center;
  font-size: 0.16rem;
  padding: 0 0.1rem;
}
</style>
<style scoped="scoped">
.navText >>> .van-notice-bar__content {
  text-align: center;
  min-width: 100%;
}
</style>